<!--
*ngIf="true" hack is required here for router-outlet to work
correctly. Otherwise, it won't register the changes on the
layout and won't update the view.
-->
@if (true) {
  <main id="main-content" tabindex="-1">
    <router-outlet></router-outlet>
  </main>
}